import { takeLatest, put, call } from 'redux-saga/effects';

import { LOADER_CLOSE, LOADER_OPEN } from '../actions';
import { ACTIVE_MODULES_GET } from '../actions/modules';
import modules from '../../api/modules';

function* activeModulesGet() {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(
      modules.activeModulesGet
    );
    yield put({ type: ACTIVE_MODULES_GET._SUCCESS, response });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > modules > activeModulesGet', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* activeModulesGetWatch() {
  yield takeLatest(ACTIVE_MODULES_GET._REQUEST, activeModulesGet);
}

export default [activeModulesGetWatch()];
